import axios from "../axios";

const supportExport = {
  addSupportTicket(params) {
    return axios.post("/users/support/ticket", params);
  }
};

export default supportExport